import React, { useEffect } from "react";

import { BiHeart } from "react-icons/bi";

function GridViewFeatured({ datas }) {
  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  return (
    <div className="adjustGrid">
      {datas.map((e, index) => {
        return (
          <div className="cardFeatured" key={index}>
            <div className="position-relative">
              <div className="mainImage">
                <img src={e.mainImg} alt="card" />
                <div className="heartLike">
                  <BiHeart /> <span className="ms-2">5</span>
                </div>
              </div>
              <div className="profileImages">
                <img src={e.profileImg} alt="profile" />
              </div>
            </div>
            <div className="cardNames">
              {e.profileName}
              <img src="signed 1.png" alt="tick" className="tick ms-2" />
            </div>
            <div className="onHover">
              <div className="onHovertrue">
                <p>azuki</p>
              </div>
              <div className="priceofImage">
                <div className="d-flex opacity-50 bid">
                  <div className="w-50 ">Price</div>
                  <div>Highest bid</div>
                </div>
                <div className="d-flex bidAMount ">
                  <div className="w-50 ">16.5 ETH</div>
                  <div>10.5 ETH</div>
                </div>
              </div>
              <button className="mt-3 buyNow">BUY NOW</button>
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default GridViewFeatured;
